import {IVanillaReaderUI} from './IVanillaReaderUI';
import {IAttributeData} from '@colibrio/colibrio-reader-framework/colibrio-core-base';
import {
    EngineEventTargetFrameworkComponent,
    IEngineEventTargetXmlElementNodeData,
    NavigationAction,
    ReaderDocumentEventState,
} from '@colibrio/colibrio-reader-framework/colibrio-readingsystem-base';
import {VanillaReaderRendererNames} from '../VanillaReader/VanillaReaderModel';
import {ContentBlockDataHtmlRenderer} from '../utils/ContentBlockDataHtmlRenderer';
import {VanillaReaderUiKeyboardShortcutController} from './VanillaReaderUiKeyboardShortcutController';
import {VanillaReaderUiMediaSessionsController} from './VanillaReaderUiMediaSessionsController';
import {ICoordinates} from '../utils/ICoordinates';
import {
    IVanillaReaderAppEvent_AMBIENT_AUDIO_READY,
    IVanillaReaderAppEvent_AMBIENT_AUDIO_NOT_FOUND,
    IVanillaReaderAppEvent_APP_LOADED,
    IVanillaReaderAppEvent_APP_ONLINE_STATE_CHANGED, IVanillaReaderAppEvent_APP_UI_OPTIONS_CHANGED,
    IVanillaReaderAppEvent_BOOKMARK_ADDED,
    IVanillaReaderAppEvent_BOOKMARK_CLICKED,
    IVanillaReaderAppEvent_BOOKMARK_DELETED,
    IVanillaReaderAppEvent_BOOKMARK_IN_VISIBLE_RANGE,
    IVanillaReaderAppEvent_BOOKMARK_OUTSIDE_VISIBLE_RANGE,
    IVanillaReaderAppEvent_BOOKMARK_TEXTLOCATION_FAILED,
    IVanillaReaderAppEvent_BOOKMARKS_LOADED,
    IVanillaReaderAppEvent_BOOKMARKS_UPDATED,
    IVanillaReaderAppEvent_CLICK,
    IVanillaReaderAppEvent_DOCUMENT_IS_AT_END,
    IVanillaReaderAppEvent_DOCUMENT_IS_AT_START,
    IVanillaReaderAppEvent_HIGHLIGHT_ADDED,
    IVanillaReaderAppEvent_HIGHLIGHT_CLICKED,
    IVanillaReaderAppEvent_HIGHLIGHT_DELETED,
    IVanillaReaderAppEvent_HIGHLIGHT_IN_VISIBLE_RANGE,
    IVanillaReaderAppEvent_HIGHLIGHT_OUTSIDE_VISIBLE_RANGE,
    IVanillaReaderAppEvent_HIGHLIGHT_TEXTLOCATION_FAILED,
    IVanillaReaderAppEvent_HIGHLIGHT_UPDATED,
    IVanillaReaderAppEvent_HIGHLIGHTS_LOADED,
    IVanillaReaderAppEvent_HIGHLIGHTS_UPDATED,
    IVanillaReaderAppEvent_KEYBOARD_EVENT,
    IVanillaReaderAppEvent_MEDIA_OBJECT_VIEW_INTENT,
    IVanillaReaderAppEvent_MEDIAPLAYER_ATTACHED,
    IVanillaReaderAppEvent_MEDIAPLAYER_CREATED,
    IVanillaReaderAppEvent_MEDIAPLAYER_DETACHED,
    IVanillaReaderAppEvent_MEDIAPLAYER_ESCAPABILITY_CONTEXT_CHANGED,
    IVanillaReaderAppEvent_MEDIAPLAYER_PLAYBACK_POSITION_CHANGED,
    IVanillaReaderAppEvent_MEDIAPLAYER_PLAYBACK_STATE_CHANGED,
    IVanillaReaderAppEvent_MEDIAPLAYER_SEEK_COMPLETED, IVanillaReaderAppEvent_MEDIAPLAYER_VOICE_LIST_CHANGED,
    IVanillaReaderAppEvent_NAVIGATION_COMPLETED,
    IVanillaReaderAppEvent_NAVIGATION_EXTERNAL_INTENT,
    IVanillaReaderAppEvent_NAVIGATION_INTERNAL_INTENT,
    IVanillaReaderAppEvent_NAVIGATION_STARTED,
    IVanillaReaderAppEvent_NAVIGATION_TREE_READY,
    IVanillaReaderAppEvent_POINTER_DOWN,
    IVanillaReaderAppEvent_POINTER_MOVE,
    IVanillaReaderAppEvent_POINTER_UP,
    IVanillaReaderAppEvent_PUBLICATION_DOWNLOAD_PROGRESS_UPDATED,
    IVanillaReaderAppEvent_PUBLICATION_LANDMARKS_READY,
    IVanillaReaderAppEvent_PUBLICATION_LOAD_FAILED,
    IVanillaReaderAppEvent_PUBLICATION_LOADED,
    IVanillaReaderAppEvent_PUBLICATION_PAGE_LIST_READY,
    IVanillaReaderAppEvent_PUBLICATION_RENDERED,
    IVanillaReaderAppEvent_PUBLICATION_SEARCH_COMPLETED,
    IVanillaReaderAppEvent_PUBLICATION_SHELF_UPDATED,
    IVanillaReaderAppEvent_PUBLICATION_STYLE_OPTIONS_CHANGED,
    IVanillaReaderAppEvent_PUBLICATION_VIEWPORT_CHANGED,
    IVanillaReaderAppEvent_READING_POSITION_UPDATED,
    IVanillaReaderAppEvent_REDUCED_MOTION_OPTION_CHANGED,
    IVanillaReaderAppEvent_RENDERER_ASPECT_RATIO_CHANGED,
    IVanillaReaderAppEvent_RENDERER_CHANGED,
    IVanillaReaderAppEvent_TEXT_SELECTED,
    IVanillaReaderAppEvent_TIMELINE_POSITION_UPDATED,
    IVanillaReaderAppEvent_TIMELINE_READY,
    IVanillaReaderAppEvent_VIEW_PAGE_MARKERS_VISIBILITY_CHANGED,
    IVanillaReaderAppEvent_VIEW_SWIPE_NAVIGATION_PROGRESS_UPDATED,
    IVanillaReaderAppEvent_VIEW_TRANSFORM_CHANGED,
    IVanillaReaderAppEvent_VIEW_TRANSITION_ENDED,
    IVanillaReaderAppEvent_VIEW_TRANSITION_STARTED,
    IVanillaReaderAppEvent_VISIBLE_CONTENT_RECTS_CHANGED,
    IVanillaReaderAppEvent_VISIBLE_CONTENT_RENDERED,
    IVanillaReaderAppEvent_VISIBLE_PAGES_CHANGED,
    IVanillaReaderAppEvent_VISIBLE_RANGE_DATA_CHANGED
} from '../VanillaReaderEventBus/IVanillaReaderAppEventTypeMap';
import {VanillaReaderLandmark} from "../VanillaReader/VanillaReaderLandmark";

export interface VanillaReaderUiVanillaReaderEventController extends IVanillaReaderUI, VanillaReaderUiKeyboardShortcutController, VanillaReaderUiMediaSessionsController {
}

/**
 * # VanillaReaderUiVanillaReaderEventController
 *
 * ## RESPONSIBILITIES
 *
 * This controller mixin class handles all events sent from the `VanillaReaderAPI` class. The event handlers do various
 * things such as to update the UI state variables with the updated application state.
 *
 * So, lots of fun and interesting stuff to see here :)
 *
 * Just as all other controller mixin classes, this class is used to add functionality to the `VanillaReaderUi` class
 * in a "modular" way. Read more about this in the `UI Components and Controller Mixins` in the README.md file.
 *
 * ## NOTE ON THE EVENT SYSTEM
 *
 * To keep a clear separation between the application logic in VanillaReader.ts and the VanillaReaderUI logic, all
 * communication between these two modules are done using the VanillaReaderAPI.
 *
 * When the GUI has something it wants the VanillaReader (and the Colibrio Reader Framework) to do, it calls one of the
 * methods on the VanillaReaderAPI class. When VanillaReader updates its state it will dispatch one or more events with
 * its updated state, This in turn triggers a callback in `VanillaReaderAPI` which calls the handler functions in this
 * class.
 *
 *      |-----------------------|                   |-----------------------|                   |-----------------------|
 *      |                       |   -- method ->    |                       |   -- method ->    |                       |
 *      |   VanillaReaderUI     |                   |   VanillaReaderAPI    |                   |     VanillaReader     |
 *      |                       |  <- callback(s) - |                       |   <- event(s) --  |                       |
 *      |-----------------------|                   |-----------------------|                   |-----------------------|
 *
 *
 * Have a look in the VanillaReaderAPI to see what events are triggered by the various API methods.
 *
 * ## RELATED TYPES
 * - VanillaReaderUi
 * - VanillaReaderAPI
 *
 */
export class VanillaReaderUiVanillaReaderEventController {

    _addVanillaReaderAPIEventListeners(): void {

        /*
        *
        * Here are all the event listeners. Almost all events are fired by the `VanillaReaderAPI` instance in response
        * to a change in the application state.
        *
        * The naming is quite intuitive I hope :)
        *
        * */
        this.vanillaReaderAPI.onAmbientAudioReady(this._vanillaReaderEvent_ambientAudioReady.bind(this));
        this.vanillaReaderAPI.onAmbientAudioNotFound(this._vanillaReaderEvent_ambientAudioNotFound.bind(this));
        this.vanillaReaderAPI.onAppLoaded(this._vanillaReaderEvent_appLoaded.bind(this));
        this.vanillaReaderAPI.onAppOnlineStateChanged(this._vanillaReaderEvent_appOnlineStateChanged.bind(this));
        this.vanillaReaderAPI.onAppUiOptionsChanged(this._vanillaReaderEvent_appUiOptionsChanged.bind(this));
        this.vanillaReaderAPI.onBookmarksLoaded(this._vanillaReaderEvent_bookmarksLoaded.bind(this));
        this.vanillaReaderAPI.onBookmarkAdded(this._vanillaReaderEvent_bookmarkAdded.bind(this));
        this.vanillaReaderAPI.onBookmarkClicked(this._vanillaReaderEvent_bookmarkClicked.bind(this));
        this.vanillaReaderAPI.onBookmarkDeleted(this._vanillaReaderEvent_bookmarkDeleted.bind(this));
        this.vanillaReaderAPI.onBookmarkTextLocationFailed(this._vanillaReaderEvent_bookmarkTextLocationFailed.bind(this));
        this.vanillaReaderAPI.onBookmarksCollectionUpdated(this._vanillaReaderEvent_bookmarksCollectionUpdated.bind(this));
        this.vanillaReaderAPI.onBookmarkInVisibleRange(this._vanillaReaderEvent_bookmarkInVisibleRange.bind(this));
        this.vanillaReaderAPI.onBookmarkOutsideVisibleRange(this._vanillaReaderEvent_bookmarkOutsideVisibleRange.bind(this));
        this.vanillaReaderAPI.onDocumentIsAtStart(this._vanillaReaderEvent_documentIsAtStart.bind(this));
        this.vanillaReaderAPI.onDocumentIsAtEnd(this._vanillaReaderEvent_documentIsAtEnd.bind(this));
        this.vanillaReaderAPI.onHighlightsLoaded(this._vanillaReaderEvent_highlightsLoaded.bind(this));
        this.vanillaReaderAPI.onHighlightAdded(this._vanillaReaderEvent_highlightAdded.bind(this));
        this.vanillaReaderAPI.onHighlightDeleted(this._vanillaReaderEvent_highlightDeleted.bind(this));
        this.vanillaReaderAPI.onHighlightUpdated(this._vanillaReaderEvent_highlightUpdated.bind(this));
        this.vanillaReaderAPI.onHighlightsCollectionUpdated(this._vanillaReaderEvent_highlightsCollectionUpdated.bind(this));
        this.vanillaReaderAPI.onHighlightClicked(this._vanillaReaderEvent_highlightClicked.bind(this));
        this.vanillaReaderAPI.onHighlightTextLocationFailed(this._vanillaReaderEvent_highlightTextLocationFailed.bind(this));
        this.vanillaReaderAPI.onHighlightInVisibleRange(this._vanillaReaderEvent_highlightInVisibleRange.bind(this));
        this.vanillaReaderAPI.onHighlightOutsideVisibleRange(this._vanillaReaderEvent_highlightOutsideVisibleRange.bind(this));
        this.vanillaReaderAPI.onReaderKeyUp(this._vanillaReaderEvent_readerKeyUp.bind(this));

        // This is one of the few intents that are sent from the `VanillaReader`. This is because the event (probably a
        // pointer up on an image element) is emitted by the Colibrio `ReaderView`. So an intent is sent to the UI so that
        // it can show the media resource in a popup dialog.
        this.vanillaReaderAPI.onMediaObjectViewIntent(this._vanillaReaderEvent_mediaObjectViewIntent.bind(this));

        this.vanillaReaderAPI.onMediaPlayerCreated(this._vanillaReaderEvent_mediaPlayerCreated.bind(this));
        this.vanillaReaderAPI.onMediaPlayerPlaybackStateChanged(this._vanillaReaderEvent_mediaPlayerPlaybackStateChanged.bind(this));
        this.vanillaReaderAPI.onMediaPlayerPlaybackPositionChanged(this._vanillaReaderEvent_mediaPlayerPlaybackPositionChanged.bind(this));
        this.vanillaReaderAPI.onMediaPlayerSeekCompleted(this._vanillaReaderEvent_mediaPlayerSeekCompleted.bind(this));
        this.vanillaReaderAPI.onMediaPlayerAttached(this._vanillaReaderEvent_mediaPlayerAttached.bind(this));
        this.vanillaReaderAPI.onMediaPlayerDetached(this._vanillaReaderEvent_mediaPlayerDetached.bind(this));
        this.vanillaReaderAPI.onMediaPlayerEscapabilityContextChanged(this._vanillaReaderEvent_mediaPlayerEscapabilityContextChanged.bind(this));
        this.vanillaReaderAPI.onMediaPlayerVoiceListChanged(this._vanillaReaderEvent_mediaPlayerVoiceListChanged.bind(this));

        // This is one of the few intents that are sent from the `VanillaReader`. A link with a target outside the publication
        // has been triggered in the Colibrio `IReaderView`. An intent is sent to the UI in order for it to decide how
        // to give the appropriate options to the user.
        this.vanillaReaderAPI.onNavigationOpenRemoteAddressIntent(this._vanillaReaderEvent_navigationOpenRemoteAddressIntent.bind(this));
        this.vanillaReaderAPI.onNavigationGotoInternalLocationIntent(this._vanillaReaderEvent_navigationGotoInternalLocationIntent.bind(this));

        this.vanillaReaderAPI.onNavigationStarted(this._vanillaReaderEvent_navigationStarted.bind(this));
        this.vanillaReaderAPI.onNavigationCompleted(this._vanillaReaderEvent_navigationCompleted.bind(this));
        this.vanillaReaderAPI.onNavigationTreeReady(this._vanillaReaderEvent_navigationTreeReady.bind(this));
        this.vanillaReaderAPI.onReaderViewPointerDown(this._vanillaReaderEvent_readerViewPointerDown.bind(this));
        this.vanillaReaderAPI.onReaderViewPointerUp(this._vanillaReaderEvent_readerViewPointerUp.bind(this));
        this.vanillaReaderAPI.onReaderViewPointerMove(this._vanillaReaderEvent_readerViewPointerMove.bind(this));
        this.vanillaReaderAPI.onClick(this._vanillaReaderEvent_click.bind(this));
        this.vanillaReaderAPI.onPublicationLoaded(this._vanillaReaderEvent_publicationLoaded.bind(this));
        this.vanillaReaderAPI.onPublicationLoadFailed(this._vanillaReaderEvent_publicationLoadFailed.bind(this));
        this.vanillaReaderAPI.onPublicationRendered(this._vanillaReaderEvent_publicationRendered.bind(this));
        this.vanillaReaderAPI.onPublicationPageListReady(this._vanillaReaderEvent_publicationPageListReady.bind(this));
        this.vanillaReaderAPI.onPublicationPageNumberVisibilityChanged(this._vanillaReaderEvent_publicationPageNumberVisibilityChanged.bind(this));
        this.vanillaReaderAPI.onPublicationDownloadProgressUpdated(this._vanillaReaderEvent_publicationDownloadProgressUpdated.bind(this));
        this.vanillaReaderAPI.onPublicationSearchCompleted(this._vanillaReaderEvent_publicationSearchCompleted.bind(this));
        this.vanillaReaderAPI.onPublicationShelfUpdated(this._appEvent_publicationShelfUpdated.bind(this));
        this.vanillaReaderAPI.onPublicationStyleOptionsChanged(this._vanillaReaderEvent_publicationStyleOptionsChanged.bind(this));
        this.vanillaReaderAPI.onPublicationViewportChanged(this._vanillaReaderEvent_publicationViewportChanged.bind(this));
        this.vanillaReaderAPI.onRendererChanged(this._vanillaReaderEvent_rendererChanged.bind(this));
        this.vanillaReaderAPI.onRendererAspectRatioChanged(this._vanillaReaderEvent_rendererAspectRatioChanged.bind(this));
        this.vanillaReaderAPI.onReducedMotionOptionChanged(this._vanillaReaderEvent_reducedMotionOptionChanged.bind(this));
        this.vanillaReaderAPI.onReadingPositionUpdated(this._vanillaReaderEvent_readingPositionUpdated.bind(this));
        this.vanillaReaderAPI.onTextSelected(this._vanillaReaderEvent_textSelected.bind(this));
        this.vanillaReaderAPI.onTimelinePositionUpdated(this._vanillaReaderEvent_timelinePositionUpdated.bind(this));
        this.vanillaReaderAPI.onVisibleContentRendered(this._vanillaReaderEvent_visibleContentRendered.bind(this));
        this.vanillaReaderAPI.onVisiblePagesChanged(this._vanillaReaderEvent_visiblePagesChanged.bind(this));
        this.vanillaReaderAPI.onTimelineReady(this._vanillaReaderEvent_timelineReady.bind(this));
        this.vanillaReaderAPI.onViewTransitionStarted(this._vanillaReaderEvent_viewTransitionStarted.bind(this));
        this.vanillaReaderAPI.onViewTransitionEnded(this._vanillaReaderEvent_viewTransitionEnded.bind(this));
        this.vanillaReaderAPI.onViewTransformChanged(this._vanillaReaderEvent_viewTransformChanged.bind(this));
        this.vanillaReaderAPI.onVisibleContentRectsChanged(this._vanillaReaderEvent_visibleContentRectsChanged.bind(this));
        this.vanillaReaderAPI.onPublicationLandmarksReady(this._vanillaReaderEvent_publicationLandmarksReady.bind(this));
        this.vanillaReaderAPI.onViewSwipeNavigationProgressUpdated(this._vanillaReaderEvent_swipeNavigationProgressUpdated.bind(this));
        this.vanillaReaderAPI.onVisibleRangeDataChanged(this._vanillaReaderEvent_visibleRangeDataChanged.bind(this));
    }

    _vanillaReaderEvent_ambientAudioReady(ev: CustomEvent<IVanillaReaderAppEvent_AMBIENT_AUDIO_READY>): void {
        this.functionButtons.enableSoundtrack(ev.detail.isPlaying);    
    }

    _vanillaReaderEvent_ambientAudioNotFound(_ev: CustomEvent<IVanillaReaderAppEvent_AMBIENT_AUDIO_NOT_FOUND>): void {
        this.functionButtons.disableSoundtrack();    
    }

    _vanillaReaderEvent_appLoaded(_ev: CustomEvent<IVanillaReaderAppEvent_APP_LOADED>): void {
        console.log('The application is all set to load publications.');
    };

    _vanillaReaderEvent_appOnlineStateChanged(ev: CustomEvent<IVanillaReaderAppEvent_APP_ONLINE_STATE_CHANGED>): void {
        let toastMsg = ev.detail.isOnline ? 'App running online' : 'App running offline';

        this.toaster.toast(toastMsg).catch(console.error);

        this.dialogOpenFile.isOffline = ev.detail.isOnline;
    };

    _vanillaReaderEvent_appUiOptionsChanged(ev: CustomEvent<IVanillaReaderAppEvent_APP_UI_OPTIONS_CHANGED>): void {
        this.activeUiOptionsData = ev.detail.uiOptionsData;
        this.dialogSettings.setViewState(ev.detail.uiOptionsData);
    };

    _vanillaReaderEvent_readerViewPointerDown(ev: CustomEvent<IVanillaReaderAppEvent_POINTER_DOWN>): void {
        this.latestReaderViewPointerDownEventTimestamp = Date.now();

        this.latestReaderViewPointerDownEventCoords = {
            x: ev.detail.srcEventData.clientX,
            y: ev.detail.srcEventData.clientY,
        };
        this.latestReaderViewPointerDownEventButton = ev.detail.srcEventData.buttons;

        // Pointer down should cancel the hover timeout
        if(this.readerViewPointerHoverTimeoutHandle) {
            clearTimeout(this.readerViewPointerHoverTimeoutHandle);
        }

    };

    /*
    *
    * This event handler takes care of deciding what to do when a pointer up has been released. In an EPUB especially
    * there are a lot of things that need to be handled correctly for the user experience to be good. Especially in
    * EPUBs that are scripted.
    *
    * In the Vanilla Reader this is extra important since it uses the familiar "click the publication to open the
    * main menu"-feature. There are quite a number of instances where you *don't* want to open the menu, such as if the
    * user,
    *
    * - clicks an HTML Form control
    * - clicks an image
    * - a details element
    * - etc
    *
    * */
    _vanillaReaderEvent_readerViewPointerUp(ev: CustomEvent<IVanillaReaderAppEvent_POINTER_UP>): void {

        // This is run after a timeout in order to catch double clicks etc. This is so that users can double
        // tap / click text without us showing the menu.
        const _internalReaderViewPointerUp = () => {
            let srcEventData = ev.detail.srcEventData;
            let ignoreEvent: boolean = false;
            this.latestReaderViewPointerUpEventCoords = {
                x: ev.detail.srcEventData.clientX,
                y: ev.detail.srcEventData.clientY,
            };
            this.readerViewPointerUpTimeoutHandle = undefined;

            // Check if the pointer event is an engine event. If not we can not reference any Colibrio specific data.
            if (this._eventDataIsPointerEngineEventData(srcEventData)) {

                let hasMediaPlayerReadAloudAttribute = srcEventData.target?.nodeData?.attributes.some((attribute: IAttributeData) => {
                    return attribute.localName === 'ibooks-readaloud' || attribute.localName === 'readaloud';
                });

                if (hasMediaPlayerReadAloudAttribute) {
                    this.startMediaPlayer(srcEventData.target?.locator?.selectors[0] || undefined);
                }

                if (srcEventData.mediaResource) {
                    // Clicks on images are handled in the `event_mediaObjectViewIntent` method, so we can return.
                    return;
                }

                let eventTarget = srcEventData.target;

                const bubbleSearchForIgnoreElement = (nodeData: IEngineEventTargetXmlElementNodeData): boolean => {

                    let nodeName = nodeData.nodeName?.toLocaleLowerCase();

                    if(!nodeName || nodeName === 'body') {
                        return false;
                    }

                    // Filter out other elements where we should not interfere in the original event behaviour
                    switch (nodeName) {
                        case 'a':
                        case 'figure':
                        case 'img':
                        case 'details':
                        case 'summary':
                        case 'button':
                        case 'select':
                        case 'input':
                        case 'textarea':
                            return true;
                            break;
                        default:
                            if(nodeData.parent) {
                                return bubbleSearchForIgnoreElement(nodeData.parent);
                            } else {
                                return false;
                            }
                    }
                }

                if(srcEventData.target?.nodeData && bubbleSearchForIgnoreElement(srcEventData.target.nodeData)) {
                    ignoreEvent = true;
                }

                let targetIsBookmarkOrHighlight = eventTarget?.frameworkComponent === EngineEventTargetFrameworkComponent.READER_VIEW_ANNOTATION;

                if (targetIsBookmarkOrHighlight || this.activeSelection) {
                    ignoreEvent = true;
                }

                if (srcEventData.readerDocumentEventState === ReaderDocumentEventState.DEFAULT_PREVENTED) {
                    ignoreEvent = true;
                }

                // If the reader is in accessibility mode we show a dialog with actions instead of the bottom menu.
                // This is done in the click event handler
                if (this.isInAccessibilityMode && !this.activeSelection) {
                    ignoreEvent = true;
                }
            }

            // If the media player is playing we should not open the menu as clicking the book page also moves the reading
            // position.
            if (this.menuMediaPlayer.stateIsPlaying && !this.initialPublicationData?.isAudiobook) {
                ignoreEvent = true;
            }

            // if the pressed button is not the left button (the button id is 1) we skip opening the menu
            if(this.latestReaderViewPointerDownEventButton !== 1) {
                ignoreEvent = true;
            }

            if (!this.latestReaderViewPointerDownEventCoords) {
                // If, for some strange reason, we do not have data about the pointer down event.
                this.latestReaderViewPointerDownEventCoords = this.latestReaderViewPointerUpEventCoords;
            }

            let pointerEventDeltas: ICoordinates = {
                x: Math.abs(this.latestReaderViewPointerDownEventCoords.x - this.latestReaderViewPointerUpEventCoords.x),
                y: Math.abs(this.latestReaderViewPointerDownEventCoords.y - this.latestReaderViewPointerUpEventCoords.y),
            };

            if (!this.showMenuOnReaderViewClick || ignoreEvent || pointerEventDeltas.x > 20 || pointerEventDeltas.y > 20) {
                return;
            } else {
                ev.preventDefault();

                if (this.menuBottom.isVisible) {
                    this.menuBottom.hide(!this.useReducedMotion);
                }
                if (this.menuSide.isVisible) {
                    this.menuSide.hide(!this.useReducedMotion);
                }
                //if (this.menuBottom.isVisible) {
                //    this.menuBottom.hide(!this.useReducedMotion);
                //} else {
                //    this.menuBottom.show(!this.useReducedMotion);
                //}
            }
        }

        if(this.readerViewPointerUpTimeoutHandle) {
            clearTimeout(this.readerViewPointerUpTimeoutHandle);
        }

        // Use setTimeout to catch double clicks.
        this.readerViewPointerUpTimeoutHandle = setTimeout(_internalReaderViewPointerUp,200);

    };

    _vanillaReaderEvent_readerViewPointerMove(ev: CustomEvent<IVanillaReaderAppEvent_POINTER_MOVE>): void {

        // This is run after a timeout in order to "throttle" the number of times we run the function.
        const _internalReaderViewPointerMove = () => {
            let srcEventData = ev.detail.srcEventData;
            if (this._eventDataIsPointerEngineEventData(srcEventData)) {
                let nodeData = srcEventData.target?.nodeData;

                if(nodeData) {

                    // Lookup the nearest node that has a href attribute. This can be the node itself.
                    let hrefNode = this._findNearestHrefValueInNodeData(nodeData);

                    if(!hrefNode || hrefNode.length < 1) {
                        return;
                    }

                    // We toast information about where the href is pointing to. If it's not a location within
                    // the publication we show just the url.
                    this.toastHrefTargetPositionInfo(hrefNode).catch();
                }

                this.readerViewPointerHoverTimeoutHandle = undefined;
            }
        }

        if(this.readerViewPointerHoverTimeoutHandle) {
            clearTimeout(this.readerViewPointerHoverTimeoutHandle);
        }

        // Use setTimeout to only run if the mouse has been still for the specified amount of time.
        this.readerViewPointerHoverTimeoutHandle = setTimeout(_internalReaderViewPointerMove,700);

    }

    _vanillaReaderEvent_click(ev: CustomEvent<IVanillaReaderAppEvent_CLICK>): void {
        let srcEventData = ev.detail.srcEventData;

        // Check if the pointer event is an engine event. If not, we can not reference any Colibrio specific data.
        if (this._eventDataIsMouseEngineEventData(srcEventData)) {

            if (srcEventData.defaultPrevented || srcEventData.readerDocumentEventState === ReaderDocumentEventState.DEFAULT_PREVENTED) {
                return;
            }

            // If the reader is in accessibility mode we show a dialog with actions instead of the bottom menu.
            if (this.isInAccessibilityMode && !this.activeSelection) {
                // Grab the locator of the latest caret position if possible as this has char offset info.
                // Otherwise, get the more low-res locator of the click event that will point to the start of the element.
                //let targetSelector = this.latestCaretLocator ? this.latestCaretLocator : srcEventData.target?.locator?.selectors[0];
                let targetSelector = srcEventData.target?.locator?.selectors[0];

                if (targetSelector) {
                    this.navigateTo(`#${targetSelector}`, false);
                    ev.preventDefault();
                    ev.stopImmediatePropagation();
                    this.dialogUiActions.show(true, true, undefined, true);
                } else {
                    console.warn('VanillaReaderUiVanillaReaderEventController._vanillaReaderEvent_click(), No locator was available in the event data so we dont show the actions dialog.');
                }
            }
        }

        // Click should cancel the hover timeout
        if(this.readerViewPointerHoverTimeoutHandle) {
            clearTimeout(this.readerViewPointerHoverTimeoutHandle);
        }

    }

    /*
    *
    * This event handler is called when the `VanillaReader` has sent the `PUBLICATION_LOADED`. This means that the
    * rendering has started. There is also a `PUBLICATION_RENDERED` that you can listen to if you want to know when the
    * first page has been rendered.
    *
    * */
    _vanillaReaderEvent_publicationLoaded(ev: CustomEvent<IVanillaReaderAppEvent_PUBLICATION_LOADED>): void {

        // If we had no publication data stored in the data store, we populate the `_initialPublicationData`
        // variable with the data sent in the event data.
        if (!this.initialPublicationData) {
            this.initialPublicationData = ev.detail.publicationData;
        }

        if (!this.initialPublicationOptionsData) {
            this.initialPublicationOptionsData = ev.detail.publicationOptionsData;
            if (this.initialPublicationOptionsData?.ttsOptions?.voiceName) {
                this.dialogSettings.setSelectedTtsVoiceOption(this.initialPublicationOptionsData.ttsOptions.voiceName);
            }
        }

        if (this._publicationOpenedCallback) {
            this._publicationOpenedCallback(this.initialPublicationData);
        }

        this._onAfterPublicationLoadedSetup(ev.detail.publicationData);

        if (this.dialogOpenFile.isOpen()) {
            this.dialogOpenFile.close(true);
        }
    };

    _vanillaReaderEvent_publicationLoadFailed(_ev: CustomEvent<IVanillaReaderAppEvent_PUBLICATION_LOAD_FAILED>): void {
        this.toaster.toast('Failed to load book. App will restart in 5 seconds.', true, 5000).catch();
        setTimeout(()=>{
            document.location.reload();
        },5200);
    }

    _vanillaReaderEvent_publicationRendered(_ev: CustomEvent<IVanillaReaderAppEvent_PUBLICATION_RENDERED>): void {
        this._onPublicationRendered();
    };

    _vanillaReaderEvent_publicationPageListReady(ev: CustomEvent<IVanillaReaderAppEvent_PUBLICATION_PAGE_LIST_READY>): void {
        if (ev.detail.pageListData) {
            this.publicationPageListData = ev.detail.pageListData;
            this.menuProgressionSlider.setSyntheticPages(this.publicationPageListData);
        } else {
            console.warn('VanillaReaderUiVanillaReaderEventController._vanillaReaderEvent_publicationPageListReady(), No page list data in the event data.');
        }
    };

    /*
    *
    * This method is called multiple times as a publication is being downloaded for offline reading.
    * The `progress` value is a number between 0 and 1.
    *
    * */
    _vanillaReaderEvent_publicationDownloadProgressUpdated(ev: CustomEvent<IVanillaReaderAppEvent_PUBLICATION_DOWNLOAD_PROGRESS_UPDATED>): void {
        if (ev.detail.progress === 1) {
            this._onPublicationDownloaded(ev.detail.publicationId);
        } else {
            this._onPublicationDownloadProgressUpdated(ev.detail.publicationId, ev.detail.progress);
        }
    };

    _vanillaReaderEvent_publicationPageNumberVisibilityChanged(ev: CustomEvent<IVanillaReaderAppEvent_VIEW_PAGE_MARKERS_VISIBILITY_CHANGED>): void {
        this.activeUiOptionsData.showPageNumbers = ev.detail.visible;
    }

    _vanillaReaderEvent_highlightsLoaded(ev: CustomEvent<IVanillaReaderAppEvent_HIGHLIGHTS_LOADED>): void {
        this.dialogHighlights?.populate(ev.detail.highlights || []);
    };

    _vanillaReaderEvent_highlightTextLocationFailed(ev: CustomEvent<IVanillaReaderAppEvent_HIGHLIGHT_TEXTLOCATION_FAILED>): void {
        this.toaster.toast(`Failed to add highlight for text "${ev.detail.text}"`, true).catch(console.warn);
    };

    _vanillaReaderEvent_highlightClicked(ev: CustomEvent<IVanillaReaderAppEvent_HIGHLIGHT_CLICKED>): void {
        let highlight = ev.detail.highlight;
        this.dialogHighlight?.setState(highlight, false);
        this.dialogHighlight?.show();
    };

    async _vanillaReaderEvent_highlightInVisibleRange(_ev: CustomEvent<IVanillaReaderAppEvent_HIGHLIGHT_IN_VISIBLE_RANGE>): Promise<void> {
        await this.toaster.toast('Visible content has highlights. Press Alt + Shift + H to list them.', true);
    };

    _vanillaReaderEvent_highlightOutsideVisibleRange(_ev: CustomEvent<IVanillaReaderAppEvent_HIGHLIGHT_OUTSIDE_VISIBLE_RANGE>): void {
    };

    _vanillaReaderEvent_highlightAdded(ev: CustomEvent<IVanillaReaderAppEvent_HIGHLIGHT_ADDED>): void {
        // Add the new bookmark to the list of selected items so that it can be filtered out as being visible.
        let selectedHighlights = this.dialogHighlights.selectedItems || [];
        selectedHighlights.push(ev.detail.highlight);
        this.dialogHighlights.setSelected(selectedHighlights);

        this.navigateTo(ev.detail.highlight.locator, true);

        this.toaster.toast('Highlight added', true).catch(console.error);
    };

    _vanillaReaderEvent_highlightDeleted(_ev: CustomEvent<IVanillaReaderAppEvent_HIGHLIGHT_DELETED>): void {
        this.toaster.toast('Highlight deleted', true).catch(console.error);
    };

    _vanillaReaderEvent_highlightUpdated(_ev: CustomEvent<IVanillaReaderAppEvent_HIGHLIGHT_UPDATED>): void {
    };

    _vanillaReaderEvent_highlightsCollectionUpdated(ev: CustomEvent<IVanillaReaderAppEvent_HIGHLIGHTS_UPDATED>): void {
        this.dialogHighlights?.populate(ev.detail.highlights);
    };

    _vanillaReaderEvent_bookmarksLoaded(ev: CustomEvent<IVanillaReaderAppEvent_BOOKMARKS_LOADED>): void {
        this.dialogBookmarks?.populate(ev.detail.bookmarks || []);
    };

    _vanillaReaderEvent_bookmarkAdded(ev: CustomEvent<IVanillaReaderAppEvent_BOOKMARK_ADDED>): void {
        // Add the new bookmark to the list of selected items so that it can be filtered out as being visible.
        let selectedBookmarks = this.dialogBookmarks.selectedItems || [];
        selectedBookmarks.push(ev.detail.bookmark);
        this.dialogBookmarks.setSelected(selectedBookmarks);

        this.navigateTo(ev.detail.bookmark.locator, true);

        this.toaster.toast('Bookmark added', true).catch(console.error);
    };

    _vanillaReaderEvent_bookmarkClicked(ev: CustomEvent<IVanillaReaderAppEvent_BOOKMARK_CLICKED>): void {
        this.vanillaReaderAPI?.deleteBookmark(ev.detail.bookmark.locator);
    };

    _vanillaReaderEvent_bookmarkDeleted(_ev: CustomEvent<IVanillaReaderAppEvent_BOOKMARK_DELETED>): void {
        this.toaster.toast('Bookmark deleted', true).catch(console.error);
    };

    _vanillaReaderEvent_bookmarkTextLocationFailed(ev: CustomEvent<IVanillaReaderAppEvent_BOOKMARK_TEXTLOCATION_FAILED>): void {
        this.toaster.toast(`Failed to add bookmark for text "${ev.detail.text}"`, true).catch(console.error);
    };

    _vanillaReaderEvent_bookmarksCollectionUpdated(ev: CustomEvent<IVanillaReaderAppEvent_BOOKMARKS_UPDATED>): void {
        this.dialogBookmarks?.populate(ev.detail.bookmarks);
    };

    async _vanillaReaderEvent_bookmarkInVisibleRange(_ev: CustomEvent<IVanillaReaderAppEvent_BOOKMARK_IN_VISIBLE_RANGE>): Promise<void> {
        await this.toaster.toast('Visible content has bookmarks. Press Alt + Shift + O to list them.', true);
    };

    _vanillaReaderEvent_bookmarkOutsideVisibleRange(_ev: CustomEvent<IVanillaReaderAppEvent_BOOKMARK_OUTSIDE_VISIBLE_RANGE>): void {
    };

    _vanillaReaderEvent_documentIsAtStart(_ev: CustomEvent<IVanillaReaderAppEvent_DOCUMENT_IS_AT_START>): void {
        if (this.dialogSettings.activeRendererTypeName === VanillaReaderRendererNames.SCROLL) {
            console.log('_vanillaReaderEvent_documentIsAtStart');
        }
    };

    async _vanillaReaderEvent_documentIsAtEnd(_ev: CustomEvent<IVanillaReaderAppEvent_DOCUMENT_IS_AT_END>): Promise<void> {
        if (this.dialogSettings.activeRendererTypeName === VanillaReaderRendererNames.SCROLL) {
            await this.toaster.toast('Book section is at end.', true);
        }
    };

    _vanillaReaderEvent_mediaPlayerAttached(_ev: CustomEvent<IVanillaReaderAppEvent_MEDIAPLAYER_ATTACHED>): void {
        if (!this.menuMediaPlayer?.isOpen()) {
            this.menuBottom.toggleReadAloudButtonState(true);
            this.menuMediaPlayer.open();
        }
    };

    _vanillaReaderEvent_mediaPlayerDetached(_ev: CustomEvent<IVanillaReaderAppEvent_MEDIAPLAYER_DETACHED>): void {
        if (this.menuMediaPlayer.isOpen()) {
            this.menuBottom.toggleReadAloudButtonState(false);
            this.menuMediaPlayer?.close();
        }
    };

    _vanillaReaderEvent_mediaPlayerEscapabilityContextChanged(ev: CustomEvent<IVanillaReaderAppEvent_MEDIAPLAYER_ESCAPABILITY_CONTEXT_CHANGED>): void {
        this.mediaPlayerEscapabilityContext = ev.detail.contextData
    };

    _vanillaReaderEvent_mediaPlayerVoiceListChanged(ev: CustomEvent<IVanillaReaderAppEvent_MEDIAPLAYER_VOICE_LIST_CHANGED>): void {
        if(!ev.detail.voiceCollection) {
            console.warn('VanillaReaderUiVanillaReaderEventController._vanillaReaderEvent_mediaPlayerVoiceListChanged: voiceCollection was undefined.')
            return;
        }
        this.dialogSettings.setTtsVoiceCollectionData(ev.detail.voiceCollection);
    };

    _vanillaReaderEvent_mediaObjectViewIntent(ev: CustomEvent<IVanillaReaderAppEvent_MEDIA_OBJECT_VIEW_INTENT>): void {

        // No image dialog if the view is in accessibility mode
        if (this.isInAccessibilityMode === true) {
            return;
        }

        // No image dialog if the view is in pan zoom mode
        if (this.isReaderViewIsInPanZoomMode === true) {
            return;
        }

        if (ev.detail.mediaUrl) {
            let description: string | undefined;
            if (ev.detail.mediaElementAttributes && ev.detail.mediaElementAttributes.length > 0) {
                description = ev.detail.mediaElementAttributes.find(attribute => attribute.localName === 'alt')?.value;
            }

            this.dialogImageViewer?.loadImage(ev.detail.mediaUrl, description);
            this.dialogImageViewer.show(false, true);
        } else {
            console.warn('_vanillaReaderEvent_mediaObjectViewIntent(): mediaUrl event data was undefined.');
        }
    };

    _vanillaReaderEvent_navigationOpenRemoteAddressIntent(ev: CustomEvent<IVanillaReaderAppEvent_NAVIGATION_EXTERNAL_INTENT>): void {
        let url = ev.detail.targetUrl;

        // Do not open urls that are local to the "com.colibrio" scope.
        if (url && !url.includes('com.colibrio')) {
            if (window.confirm('Do you wish to open "' + url + '"?')) {
                window.open(url);
            }
        }
    };


    /*
    *
    * This method is called when a navigation within the publication content has been triggered.
    * There are some specific cases where you will not simply navigate to the location, such if you click on a footnote.
    * In the code below a popup is shown when the user clicks an HTML link to a footnote.
    *
    * */
    async _vanillaReaderEvent_navigationGotoInternalLocationIntent(ev: CustomEvent<IVanillaReaderAppEvent_NAVIGATION_INTERNAL_INTENT>): Promise<void> {
        if (ev.detail.srcEvent?.relatedEvent?.target) {

            let nodeData = ev.detail.srcEvent.relatedEvent.target.nodeData;
            let srcEvent = ev.detail.srcEvent;

            if (nodeData) {

                // Let's check if this is a noteref element
                let isNoteRef = nodeData.attributes.find((attribute) => {
                    return attribute.value === 'noteref';
                });

                if (isNoteRef) {
                    ev.preventDefault();

                    let noteRefLocator = ev.detail.srcEvent.relatedEvent.target.contentLocation?.getLocator().toString();

                    let internalHref = nodeData.attributes.find((attribute) => {
                        return attribute.localName === 'href';
                    });

                    if (!internalHref) {
                        console.warn('_vanillaReaderEvent_navigationGotoInternalLocationIntent, link has no "href" attribute. ');
                        return;
                    }

                    let id = internalHref.value.slice(internalHref.value.indexOf('#') + 1);
                    let footnoteContentBlock = this.getFootnoteLandmarkByElementId(id);
                    if (footnoteContentBlock && srcEvent.locator) {
                        footnoteContentBlock = (footnoteContentBlock as VanillaReaderLandmark);
                        let footerHtmlContent = new ContentBlockDataHtmlRenderer().rendererToString([(await footnoteContentBlock.serialize(true, true))]);

                        this.dialogFootnote.show(false, true, this._onDialogFootnoteClosed.bind(this), footerHtmlContent, srcEvent.locator.toString(), noteRefLocator);
                    } else {
                        console.warn(`_vanillaReaderEvent_navigationGotoInternalLocationIntent, could not find a footnote with id "${id}".`);
                    }

                } else if (ev.detail.srcEvent && ev.detail.srcEvent.locator) {
                    // Not a noteref so we can do an internal navigation as usual.
                    ev.preventDefault();
                    let locator = ev.detail.srcEvent.locator.toString();
                    this.navigateTo(locator);
                }

            } else if (ev.detail.srcEvent && ev.detail.srcEvent.locator) {
                // Probably a PDF since there is no nodeData.
                ev.preventDefault();
                let locator = ev.detail.srcEvent.locator.toString();
                this.navigateTo(locator);
            }

        } else {
            console.warn('_vanillaReaderEvent_navigationGotoInternalLocationIntent, got invalid locator. ');
        }
    };

    _vanillaReaderEvent_navigationStarted(_ev: CustomEvent<IVanillaReaderAppEvent_NAVIGATION_STARTED>): void {
        this.isReaderViewNavigating = true;
        this._cancelAllActiveTimeouts();
    };

    _vanillaReaderEvent_navigationCompleted(_ev: CustomEvent<IVanillaReaderAppEvent_NAVIGATION_COMPLETED>): void {
        this.isReaderViewNavigating = false;
        if (this.menuBottom.isVisible) {
            this.menuBottom.hide(!this.useReducedMotion);
        }

        // Deselect bottom nav buttons. One off the buttons may have been toggled when the user swiped
        // in order to indicate pending navigation action (in _vanillaReaderEvent_swipeNavigationProgressUpdated()).
        //this.buttonNext.selected = false;
        //this.buttonPrevious.selected = false;
    };

    _vanillaReaderEvent_publicationSearchCompleted(ev: CustomEvent<IVanillaReaderAppEvent_PUBLICATION_SEARCH_COMPLETED>): void {
        if (ev.detail.resultSet) {
            this.dialogSearch?.populate(ev.detail.resultSet);
            this.dialogSearch?.show();
            this.toaster.toast(`Search returned ${ev.detail.resultSet.length} results.`, true).catch(console.warn);
        } else {
            this.toaster.toast(`Search returned no results.`, true).catch(console.warn);
        }
    };

    _appEvent_publicationShelfUpdated(ev: CustomEvent<IVanillaReaderAppEvent_PUBLICATION_SHELF_UPDATED>): void {
        this.dialogOpenFile.updateShelfItems(ev.detail.shelfItems).catch(console.warn);
    };

    _vanillaReaderEvent_publicationStyleOptionsChanged(_ev: CustomEvent<IVanillaReaderAppEvent_PUBLICATION_STYLE_OPTIONS_CHANGED>): void {
    };

    _vanillaReaderEvent_publicationViewportChanged(ev: CustomEvent<IVanillaReaderAppEvent_PUBLICATION_VIEWPORT_CHANGED>): void {
        this.visiblePageClientRects = ev.detail.visiblePageClientRects;
    };

    _vanillaReaderEvent_timelinePositionUpdated(ev: CustomEvent<IVanillaReaderAppEvent_TIMELINE_POSITION_UPDATED>): void {
        let position = ev.detail.timelinePosition;
        if (position !== undefined && position >= 0) {
            this.menuProgressionSlider?.updateSliderProgressionValue(position);
            this.latestTimelinePosition = position;
        } else {
            console.warn(`VanillaReaderUI._vanillaReaderEvent_timelineUpdateIntent(): timelinePosition value ${position} is not a valid postion.`);
        }
    };

    _vanillaReaderEvent_rendererChanged(_ev: CustomEvent<IVanillaReaderAppEvent_RENDERER_CHANGED>): void {};

    _vanillaReaderEvent_rendererAspectRatioChanged(ev: CustomEvent<IVanillaReaderAppEvent_RENDERER_ASPECT_RATIO_CHANGED>): void {
        this.activeUiOptionsData.ignoreAspectRatio = ev.detail.ignoreAspectRatio;
        this.dialogSettings?.setRendererAspectRatioOption(ev.detail.ignoreAspectRatio);
    };

    _vanillaReaderEvent_reducedMotionOptionChanged(ev: CustomEvent<IVanillaReaderAppEvent_REDUCED_MOTION_OPTION_CHANGED>): void {
        this.activeUiOptionsData.useReducedMotion = ev.detail.useReducedMotion;
        this.dialogSettings?.setUseReducedMotionOption(ev.detail.useReducedMotion);
        this.readingRuler.useReducedMotion = this.useReducedMotion;
    };

    _vanillaReaderEvent_readingPositionUpdated(ev: CustomEvent<IVanillaReaderAppEvent_READING_POSITION_UPDATED>): void {

        this.setReadingPositionData(ev.detail.readingPositionData)

        // Only focus on reading position if there is no dialog open, and that the scroll renderer is not used.
        if (!this.activeDialogTitle && this.dialogSettings.activeRendererTypeName !== VanillaReaderRendererNames.SCROLL && !this.menuMediaPlayer.stateIsPlaying) {
            this.focusOnReadingPosition();
        }

        // Move ruler along with TTS and MO, unless the scroll renderer is active.
        if (this.readingRuler.isVisible && this.dialogSettings.activeRendererTypeName !== VanillaReaderRendererNames.SCROLL && (this.readingRuler.snapToContentLineBoxes || this.menuMediaPlayer.stateIsPlaying)) {
            setTimeout(() => {
                this.moveReadingRulerToReadingPosition();
            }, 0);
        }
    };

    _vanillaReaderEvent_navigationTreeReady(ev: CustomEvent<IVanillaReaderAppEvent_NAVIGATION_TREE_READY>): void {
        if (ev.detail.navigationTreeData) {
            this.initializeNavigationTree(ev.detail.navigationTreeData)
        } else {
            console.warn('VanillaReaderUiVanillaReaderEventController._vanillaReaderEvent_navigationTreeReady(), event data did not contain any navigation tree data.');
        }
    };

    _vanillaReaderEvent_readerKeyUp(ev: CustomEvent<IVanillaReaderAppEvent_KEYBOARD_EVENT>): void {
        this._handleKeyboardShortcut(ev.detail.srcEventData.key, ev.detail.srcEventData.modifiers.alt, ev.detail.srcEventData.modifiers.shift, ev.detail.srcEventData.modifiers.control);
    };

    _vanillaReaderEvent_textSelected(ev: CustomEvent<IVanillaReaderAppEvent_TEXT_SELECTED>): void {
        this.latestCaretLocatorData = ev.detail.srcEventData.locator || undefined;
        if (ev.detail.srcEventData.isRange) {
            clearTimeout(this.selectionTimeoutHandle);

            this.activeSelection = {
                locatorData: ev.detail.srcEventData.locator,
                selector: '#' + ev.detail.srcEventData.locator?.selectors[0],
                isRange: ev.detail.srcEventData.isRange,
                selectionText: ev.detail.srcEventData.selectionText || '',
            };

            this.fabHighlight.show();
            this.fabSpeakText.show();

        } else {
            // Wait a bit before clearing the activeSelection variable in order to not create a racing condition
            // when the highlight button is pressed and the selection gets cleared.
            this.selectionTimeoutHandle = setTimeout(() => {
                this.activeSelection = undefined;
                this.fabHighlight.hide();
                this.fabSpeakText.hide();

            }, 500);
        }

        // If the media player is active, we should move (seek to) the playback position to the locator that points to.
        // This way the user can easily tap or click on the content they want to listen to when using TTS, or in a book with MO.
        if (this.menuMediaPlayer.isOpen() && ev.detail.srcEventData.locator && !ev.detail.srcEventData.isRange) {
            this.seekToLocatorWithinVisibleRange(ev.detail.srcEventData.locator);
        }


    };

    _vanillaReaderEvent_visibleRangeDataChanged(ev: CustomEvent<IVanillaReaderAppEvent_VISIBLE_RANGE_DATA_CHANGED>): void {
        let visibleRangeData = ev.detail.visibleRangeData;
        if (visibleRangeData) {
            this.latestContentRangeData = visibleRangeData;
            this.visibleContentRectData = visibleRangeData.visibleContentRects;
            this.dialogHighlights.setSelected(visibleRangeData.highlights);
            this.dialogBookmarks.setSelected(visibleRangeData.bookmarks);
            this.dialogContents.setActiveTocItems(visibleRangeData.navItems);
            this.dialogContents.setActivePageItems(visibleRangeData.navItems);

            if (visibleRangeData.timelineRange) {
                this.menuProgressionSlider.setVisibleRangeData(visibleRangeData);

                if (this.latestTimelinePosition) {
                    this.menuProgressionSlider?.updateSliderProgressionValue(this.latestTimelinePosition);
                }
                if (this.vanillaReaderButtonContainerElement.querySelector("#vanilla-reader__slider-progression")) {
                    (this.vanillaReaderButtonContainerElement.querySelector("#vanilla-reader__slider-progression") as HTMLElement).classList.remove("loading");
                }
            } else {
                console.warn('VanillaReaderUiVanillaReaderEventController._vanillaReaderEvent_visibleRangeDataChanged(), Unable to get get timelineRange from visibleRangeData.');
            }

            if (this.visibleContentRectData && this.visibleContentRectData.length > 0) {
                this.readingRuler.setContentLineBoxes(this.visibleContentRectData);
            }

            // No moving the ruler if we have the scroll renderer.
            if (this.readingRuler.isVisible && this.dialogSettings.activeRendererTypeName !== VanillaReaderRendererNames.SCROLL) {
                this.moveReadingRulerToReadingPosition();
            }

        } else {
            console.warn('_vanillaReaderEvent_visibleRangeDataChanged: The event did not contain any range data.')
        }

    };

    _vanillaReaderEvent_visibleContentRendered(ev: CustomEvent<IVanillaReaderAppEvent_VISIBLE_CONTENT_RENDERED>): void {
        let visibleRangeData = ev.detail.visibleRangeData;
        if (visibleRangeData) {
            this.visibleContentRectData = visibleRangeData.visibleContentRects;

            if (this.visibleContentRectData && this.visibleContentRectData.length > 0) {
                this.readingRuler.setContentLineBoxes(this.visibleContentRectData);
            }

            //console.log('_vanillaReaderEvent_visibleContentRendered', this.visibleElementClientRects);
        } else {
            console.warn('_vanillaReaderEvent_visibleContentRendered: The event did not contain any range data.')
        }
    };

    _vanillaReaderEvent_visiblePagesChanged(ev: CustomEvent<IVanillaReaderAppEvent_VISIBLE_PAGES_CHANGED>): void {
        let visibleRangeData = ev.detail.visibleRangeData;
        if (visibleRangeData) {
            this.visibleContentRectData = visibleRangeData.visibleContentRects;

            if (this.visibleContentRectData && this.visibleContentRectData.length > 0) {
                this.readingRuler.setContentLineBoxes(this.visibleContentRectData);
            }
        } else {
            console.warn('_vanillaReaderEvent_visiblePagesChanged: The event did not contain any range data.')
        }

    };

    _vanillaReaderEvent_timelineReady(ev: CustomEvent<IVanillaReaderAppEvent_TIMELINE_READY>): void {
        this.initializeProgressionTimeline(ev.detail.timelineData);

        // If this is a PDF we don't need to fetch landmarks as PDFs do not contain any meaningful landmark semantics
        // other than those presented in the navigation metadata.
        if (this.initialPublicationData?.format !== 'application/pdf') {
            this._populatePublicationLandmarks();
        }
    };

    _vanillaReaderEvent_publicationLandmarksReady(ev: CustomEvent<IVanillaReaderAppEvent_PUBLICATION_LANDMARKS_READY>): void {
        this.publicationHeadingLandmarks = ev.detail.headings || [];
        this.publicationFootnoteLandmarks = ev.detail.footnotes || [];
        this.publicationFigureLandmarks = ev.detail.figures || [];
        this.publicationTableLandmarks = ev.detail.tables || [];
        this.publicationListLandmarks = ev.detail.lists || [];
    };

    _vanillaReaderEvent_swipeNavigationProgressUpdated(ev: CustomEvent<IVanillaReaderAppEvent_VIEW_SWIPE_NAVIGATION_PROGRESS_UPDATED>): void {
        let navigationAction = ev.detail.srcEventData.pendingNavigationAction;
        this.buttonNext.selected = false;
        this.buttonPrevious.selected = false;

        switch (navigationAction) {
            case NavigationAction.NEXT_RENDERABLE_PAGE:
            case NavigationAction.NEXT_CONTENT_RANGE:
                this.buttonNext.selected = true;
                break;
            case NavigationAction.PREVIOUS_CONTENT_RANGE:
            case NavigationAction.PREVIOUS_RENDERABLE_PAGE:
                this.buttonPrevious.selected = true;
                break
            default:
        }
    }

    _vanillaReaderEvent_viewTransitionStarted(_ev: CustomEvent<IVanillaReaderAppEvent_VIEW_TRANSITION_STARTED>): void {
        this.isReaderViewTransitioning = true;
    };

    _vanillaReaderEvent_viewTransitionEnded(_ev: CustomEvent<IVanillaReaderAppEvent_VIEW_TRANSITION_ENDED>): void {
        this.isReaderViewTransitioning = false;
        this.activeTransformData = undefined;
    };

    /**
     *
     * When the user is panning and zooming, this method is called with the updated transform data. The transform data
     * can also be `undefined` in which case the zoom has been reset.
     *
     * */
    _vanillaReaderEvent_viewTransformChanged(ev: CustomEvent<IVanillaReaderAppEvent_VIEW_TRANSFORM_CHANGED>): void {


        if (ev.detail.transformData && !this.isReaderViewIsInPanZoomMode) {
            this.isReaderViewIsInPanZoomMode = true;
            if (!this.panZoomTool.isActive) {
                this.panZoomTool.activate();
                this.panZoomTool.enablePanning();
            }

        } else if (!ev.detail.transformData?.transformData && this.isReaderViewIsInPanZoomMode) {
            this.isReaderViewIsInPanZoomMode = false;
            this.panZoomTool.deactivate();
        }

        this.activeTransformData = ev.detail.transformData;

        this.panZoomTool.activeTransformData = this.activeTransformData?.transformData;

        if (this.activeTransformData && this.isInReadingRulerMode) {
            if (this.activeTransformData.transformData?.animating || this.activeTransformData.transformData?.userGestureActive) {
                this.hideReadingRuler(false);
            } else {

                setTimeout(() => {
                    this.showReadingRuler(false);
                }, 500);
            }
        } else if (!this.activeTransformData && this.isInReadingRulerMode) {

            // As there is no transform data, we are no longer zoomed in.
            // However, we are still supposed to show the reading ruler.

            setTimeout(() => {
                this.showReadingRuler(false);
            }, 500);
        }
    };

    _vanillaReaderEvent_visibleContentRectsChanged(ev: CustomEvent<IVanillaReaderAppEvent_VISIBLE_CONTENT_RECTS_CHANGED>): void {
        this.visibleContentRectData = ev.detail.clientRects;
        this.readingRuler.setContentLineBoxes(this.visibleContentRectData);
    }

    _vanillaReaderEvent_mediaPlayerCreated(_ev: CustomEvent<IVanillaReaderAppEvent_MEDIAPLAYER_CREATED>): void {
        this._onMediaPlayerIsReadyToPlay();
    };

    // The `SyncMediaPlayer` instance (TTS, MO and Audiobooks) in the `VanillaReader` has started playing, or has paused.
    _vanillaReaderEvent_mediaPlayerPlaybackStateChanged(ev: CustomEvent<IVanillaReaderAppEvent_MEDIAPLAYER_PLAYBACK_STATE_CHANGED>): void {

        this.latestSyncMediaPlaybackStateData = ev.detail.state;

        if (ev.detail.state.isPaused) {
            this.menuMediaPlayer.stateIsPlaying = false;
            this.fabSpeakText.stateIsSpeaking = false;
        } else {
            this.menuMediaPlayer.stateIsPlaying = true;
        }

        this.fabMediaPlayer.stateIsPlaying = this.menuMediaPlayer.stateIsPlaying;

        if (window.navigator.mediaSession) {
            this.onMediaPlayerPlaybackStateChanged(ev.detail.state);
        }
    };

    // The `VanillaReaderAudiobookMediaPlayer` instance in the `VanillaReader` has progressed to a new timeline position.
    // Note: This event fires every 1000ms.
    _vanillaReaderEvent_mediaPlayerPlaybackPositionChanged(ev: CustomEvent<IVanillaReaderAppEvent_MEDIAPLAYER_PLAYBACK_POSITION_CHANGED>): void {

        this.latestSyncMediaPlaybackStateData = ev.detail.state;

        if (window.navigator.mediaSession && ev.detail.state) {
            this.onMediaPlayerPlaybackPositionChanged(ev.detail.state);
        }
    };

    // The `VanillaReaderAudiobookMediaPlayer` instance in the `VanillaReader` has progressed to a new segment.
    _vanillaReaderEvent_mediaPlayerSeekCompleted(ev: CustomEvent<IVanillaReaderAppEvent_MEDIAPLAYER_SEEK_COMPLETED>): void {
        let playbackState = ev.detail.state;

        this.latestSyncMediaPlaybackStateData = playbackState;

        if (window.navigator.mediaSession) {
            this.onMediaPlayerSeekCompleted(playbackState);
        }

        if (ev.detail.state.navigationItems && ev.detail.state.navigationItems.length >= 0) {
            // Only grab the first item in the navigaionItems array to circumvent a bug in Beta1
            this.dialogContents?.setActiveTocItems([ev.detail.state.navigationItems[0]]);
            this.dialogContents?.setActivePageItems([ev.detail.state.navigationItems[0]]);
        }
    };

    _cancelAllActiveTimeouts(): void {
        if(this.readerViewPointerHoverTimeoutHandle) {
            clearTimeout(this.readerViewPointerHoverTimeoutHandle);
        }

        if(this.selectionTimeoutHandle) {
            clearTimeout(this.selectionTimeoutHandle);
        }

        if(this.readerViewPointerUpTimeoutHandle) {
            clearTimeout(this.readerViewPointerUpTimeoutHandle);
        }

    }

}
